import SellBooksViewForm from "Components/Admin/AdminSellBooks/SellBooksViewForm";
import { Header } from "Components/Admin/StyleComponent/Header";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useGetSellBookByIdQuery } from "../../Services/Admin/AdminSellBooksApiSlice";


const AdminSellBooksView: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const {
    data: sellBook,
    isLoading,
    isError,
  } = useGetSellBookByIdQuery(Number(id), {
    skip: !id,
  });

  if (isLoading) {
    return <div className="p-6">Loading...</div>;
  }

  if (isError || !sellBook) {
    return (
      <div className="p-6 text-red-600">
        Failed to load sell book details
      </div>
    );
  }

  return (
    <div className="font-body p-6 mx-auto">
      <button
        onClick={() => navigate(-1)}
        className="mb-4 border px-3 py-1"
      >
        ← Back
      </button>

      <Header title="View Sell Book" />

      <div className="bg-white border rounded p-6">
        <SellBooksViewForm data={sellBook} />
      </div>
    </div>
  );
};

export default AdminSellBooksView;
